import React, { FC } from 'react';

import {
	SelectField,
	InputField,
	RequiredNote,
	TextAreaField,
	FaBox,
	FaCheckCircle,
	FaClock,
	FaFileInvoiceDollar,
	FaPercentage,
	FaUser,
	DateTimeField,
	DomainFormProps
} from '@/Shared';


/**
 * =====================================================
 * Component: LeaseForm
 * =====================================================
 *
 *
 * Domain-specific form UI for Lease.
 * Mounted inside GenericDomainForm.
 *
 * Responsibilities:
 * - Render lease fields
 * - Use data from formVM (options, values)
 *
 * No permissions, no loading, no orchestration logic here.
 *
 * Author: Samano CASTRE
 * Date: February 15, 2026
 */
const LeaseForm: FC<DomainFormProps> = ({
	domainFormHook,
	formRef
}) => {

	const { entityFormVM } = domainFormHook;

	/**
	 * =====================================================
	 * Main Form Rendering
	 * =====================================================
	 *
	 * Fieldsets organize the form into logical sections for clarity.
	 */
	return (

		<div className='fieldset-wrapper'>
			<fieldset>
				<legend>Informations générales</legend>

				<SelectField
					label="Transaction"
					required
					name="transactionId"
					options={entityFormVM.transactionOptions} // tu dois exposer transactionOptions dans LeaseFormViewModel
					icon={<FaBox />}
					scrollParent={formRef.current}
				/>

				<SelectField
					icon={<FaFileInvoiceDollar />}
					label="Type de lease"
					required
					name="leaseType"
					options={entityFormVM.leaseTypeOptions} // idem, expose leaseTypeOptions
					scrollParent={formRef.current}
				/>

				<DateTimeField
					required
					label="Date début lease"
					dateName="leaseStart"
				/>
				<DateTimeField
					required
					label="Date fin lease"
					dateName="leaseEnd"
				/>
				<RequiredNote />
			</fieldset>

			<fieldset>
				<legend>Infos. complémentaires</legend>
				<InputField
					icon={<FaPercentage />}
					label="Révision (%)"
					name="revisionRate"
					type="number"
				/>
				<InputField
					icon={<FaClock />}
					label="Fréquence révision"
					name="revisionFrequency"
				/>
				<TextAreaField

					label="Activité"
					name="activity"
					placeholder='Saisir activité du professionnel'
				/>
				<TextAreaField
					label="Description usage"
					name="usageDescription"
					placeholder="Décrire l'usage qui va être fait du bien"
				/>
			</fieldset>


			<fieldset>
				<legend>Options & Locataire(s) </legend>
				<SelectField
					icon={<FaCheckCircle />}
					label="Options"
					required
					name="leaseOptions"
					options={entityFormVM.getLeaseOptions()} // idem, expose leaseTypeOptions
					scrollParent={formRef.current}
					isMulti
				/>
				<SelectField
					icon={<FaUser />}
					label="Locataires"
					name="tenants"
					options={entityFormVM.tenantsOptions} // idem, expose leaseTypeOptions
					isMulti
					scrollParent={formRef.current}
				/>
			</fieldset>
		</div>

	);
};

export default LeaseForm;
